import { Box, HStack, Text, Image } from '@chakra-ui/react';
import { Handle, Position } from 'reactflow';

import StartNodeIcon from '../../../../assets/projects/start.svg';
import { NODE_SIZE, START_NODE_WIDTH } from '../../../../constants';

export const StartNode = () => {
  return (
    <Box bg="white">
      <HStack
        justify="center"
        border="1px"
        borderColor="custom_green.5"
        borderRadius="md"
        w={`${START_NODE_WIDTH}px`}
        h="8"
      >
        <Text fontSize="xs" fontWeight="medium">
          Start
        </Text>

        <Image src={StartNodeIcon} />
      </HStack>

      <Handle
        type="source"
        position={Position.Bottom}
        id="b"
        style={{ width: NODE_SIZE, height: NODE_SIZE }}
      />
    </Box>
  );
};
